import { CleaningTourRoutes } from "./routes"

export const CleaningTourPage = () => {
    return <CleaningTourRoutes />
}
